import React from 'react';
import PropTypes from 'prop-types';

import styles from './troy.module.scss';
import headPic from '../../../assets/img/allgemein/04_textmarker.png';

import DemandTable from '.';

const TroyDemandTable = ({
  items,
  extended,
  balance,
  currency,
  blur,
  token,
}) => (
  <DemandTable
    {...{ items, balance, currency, blur, styles, headPic, extended, token }}
  />
);

TroyDemandTable.propTypes = {
  items: PropTypes.array,
  balance: PropTypes.number,
  currency: PropTypes.string,
  blur: PropTypes.bool,
  extended: PropTypes.array,
};

export default TroyDemandTable;
